export enum CrudOps {
    Create = 1,
    Read = 2,
    Update = 3,
    Delete = 4,
    UpdateGroup = 5,
    DeleteGroup = 6
}
